import React,{useEffect, useState,forwardRef,useImperativeHandle} from 'react'
import { Form,Input, InputNumber, Button, Modal,Upload, message ,Radio,Select,Space,Tooltip,Image} from 'antd';
import { ResDataType } from '@/services/ajax';
import { saveActivity,activityDetail,saveActivityStatus } from '@/services/activity';
import { upload } from '@/services/product';
import { PlusOutlined,ExclamationCircleOutlined,QuestionCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { DataType } from '../column';
import usePagAndCommon from '@/hooks/usePagAndCommon';
import useChannelList from '@/hooks/useChannelList';
import { cycleList,MAX_IMAGE_FILE_SIZE,gradeList,imgSizeList,ExampleImgList,TooltipTextList } from "@/constant"
const { TextArea } = Input;
 
interface ActivityImage {
    instructionsImg:string,
    cardImg:string,
    backgroundImg:string,
    imageUrl:string,
}

const ActivityContent = (props:any,ref:any) => {
    const { save,refresh } = props;
    const [modal, contextHolder] = Modal.useModal();
    const { curType,setCurType,isModalOpen,setIsModalOpen } = usePagAndCommon();
    const { getChannelList,channelName,curChannelList,handleSearch } = useChannelList();
    const [form] = Form.useForm();
    const [curImg,setCurImg] = useState('');
    const [previewImg,setPreviewImg] = useState<string>('');
    const [curActivity,setCurActivity] = useState<any>({});
    const [activityImage,setActivityImage] = useState<ActivityImage>({
        instructionsImg:'',
        cardImg:'',
        backgroundImg:'',
        imageUrl:'',
    });
    const [isDisable,setIsDisable] = useState(false);
    const [previewVisible, setPreviewVisible] = useState<any>(false);
    const gradeDefault = {
        gradeACount:3,
        gradeBCount:6,
        gradeCCount:12,
    }
    const showModal = async (type: string, id?: number | null) => {
        setCurType(type);
        getChannelList();
        let cur: any = {};
        if (id) {
            cur = await getDetails(id);
            setCurActivity(cur);
        } else {
            setCurActivity({});
            form.resetFields();
        }
        setIsDisable(cur?.status == 0);
        // // 需要处理的所有字段  'startDate', 'endDate', 'status','receiveMode', 'delayCollectionDay'
        // const fields = [
        //     'name', 'description', 'instructions', 'instructionsImg',
        //      'cardImg', 'backgroundImg', 'cycle','gradeACount','gradeBCount','gradeCCount',
        //     'participants', 'receiveCycle', 'imageUrl', 'cycleNum', 'cycleTotal'
        // ];
    
        // const dateFields = ['startDate', 'endDate'];
    
        // const formValues = fields.reduce((acc, key) => {
        //     let value = cur?.[key] ?? '';
        //     if (dateFields.includes(key)) {
        //         value = value ? dayjs(value) : null;
        //     }
        //     acc[key] = value;
        //     return acc;
        // }, {} as Record<string, any>);
    
        const imageFields = ['instructionsImg', 'cardImg', 'backgroundImg', 'imageUrl'];
        const imageValues = imageFields.reduce((acc, key) => {
            acc[key] = cur?.[key] ?? '';
            return acc;
        }, {} as Record<string, any>);
    
        setActivityImage(imageValues as ActivityImage);
    
        if (id) {
            form.setFieldsValue(cur);
        } else {
            form.setFieldsValue({cycle:3,...gradeDefault,cycleNum:1})
        }
    
        setIsModalOpen(true);
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (!activityImage) {
                message.warning(`请将图片上传完整`);
                return; 
            }
            for (const key in activityImage) {
                if (!activityImage[key as keyof ActivityImage] && key != 'instructionsImg') {
                    message.warning(`请将图片上传完整`);
                    return;
                }
            }
            const res = await saveActivity({...values,status:1,id:curType=='add'? "0" :curActivity.id,...activityImage,receiveMode:"1",participants:0}) as ResDataType;
            if (res.code == 0) {
                message.success('保存成功');    
                save(curType=='add'? { id:res.data } :curActivity,curType)
                setIsModalOpen(false);
            } else {
                message.error(res.message);
            }
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    const getDetails = async (id?:number) => {
        if (id) {
            const res = await activityDetail(id) as ResDataType;
            return res.data
        }
        return {}
    }

    const uploadProps = {
        name: 'file',
        multiple: false,
        showUploadList: false,
        customRequest: ({ file, onSuccess, onError, onProgress }:any) => {
            if (file.size > MAX_IMAGE_FILE_SIZE) {
                message.error('文件大小不能超过 500KB');
                return; 
            }
            const formData = new FormData();
            formData.append('File', file);
            upload(formData).then((res:any)=> {
                onSuccess(res.data);
                setActivityImage({...activityImage,[curImg]:res.data.url})
            message.success('上传成功');})
            .catch((err:any)=> {
                onError(err);
                message.error('上传失败');}) 
        },
    };


    const handleChangeStatus = async () => {
        const status = isDisable ? 1 : 0
        const res = await saveActivityStatus({activityId:curActivity.id,status}) as ResDataType;
        if (res.code!= 0) {
          message.error(res.message);
          return;
        }
        refresh();
        setIsModalOpen(false);
      }

    useImperativeHandle(ref, () => ({
        open: (type:string,id?:number | null,row?:DataType | null) => showModal(type,id),
    }))

    const confirm = () => {
        if (curActivity.status == 0) {
            modal.confirm({
                title: '提示',
                icon: <ExclamationCircleOutlined />,
                content: '活动进行中，操作需谨慎！确认下架吗？',
                okText: '确认',
                cancelText: '取消',
                onOk: handleChangeStatus
            });
        } else {
            handleChangeStatus();
        }
      };
      const labelTips = ()=>{
        return (<>
            <span>分发期数 <span style={{ fontSize:'12px',color:'red' }}>确定后不可修改</span></span>
        </>)
      }
      const tips = (text:string)=>{
        return (<>
            <span>请输入档次{text}可领取次数</span>
        </>)
      }
      const imgTips = (field: keyof typeof imgSizeList) =>{
        return (
            <div style={{ marginTop: 8,fontSize:'12px' }}>建议尺寸<span style={{color:'red'}}>{imgSizeList[field]}</span>，大小不超过<span style={{color:'red'}}>500KB</span></div>
        )
      }
      const exmpImg = (url:string)=>{
        return (
            <div style={{ textAlign:'center',fontSize:'12px' }} ><Button type="link" onClick={()=>{
                setPreviewImg(url)
                setPreviewVisible(true);
            }}>示例图</Button></div> 
        )
      }
      const toolTipContent = (title:string,tipText:string)=>{
            return (
                <div>
                    {title}
                    <Tooltip title={tipText} >
                        <span style={{ marginLeft:'5px' }}><QuestionCircleOutlined /></span>
                    </Tooltip>
                </div>
                
            )
        }
    return(
        <Modal maskClosable={false} footer={(_, { OkBtn, CancelBtn }) => (
            <>
              {curType!='add' && <Button type="primary" onClick={()=>{ confirm() }}>{ curActivity.status == 0 ?'下架':'上架'}</Button>}
              <CancelBtn />
              <OkBtn />
            </>
          )} width={600} title={curType=='add'?'创建新权益包':'编辑权益包'}  okText="确定" cancelText="取消" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
            <>
           {contextHolder}
           <Form
                form={form}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                layout="vertical"
                style={{ maxWidth: 600 }}
                className='formBox'
                >
                    <div className='flexBox'>
                        <Form.Item style={{ width:'100%' }} label="权益包标题" name='name' rules={[{ required: true, message: '请输入权益包标题' }]}>
                            <Input disabled={isDisable} showCount maxLength={20} placeholder='请输入权益包标题' />
                        </Form.Item>
                        {/* <Form.Item style={{ width:'32%' }} label="渠道" name='supplyChannelId' rules={[{ required: true, message: '请选择渠道' }]}>
                            <Select
                                disabled={isDisable}
                                showSearch
                                placeholder="请选择渠道"
                                optionFilterProp="label"
                                value={channelName}
                                onSearch={handleSearch}
                                options={curChannelList}
                            />
                        </Form.Item> */}
                    </div>
                <div className='flexBox'>
                    
                    
                    {/* <Form.Item style={{ width:'32%' }} label="权益包参与人数" name='participants' rules={[{ required: true, message: '输入权益包参与人数' }]}>
                        <InputNumber disabled={isDisable} placeholder='请输入权益包参与人数' style={{ width: '100%' }} min={1} />
                    </Form.Item> */}
                    <Form.Item style={{ width:'49%' }} label={labelTips()} name='cycleTotal' rules={[{ required: true, message: '请输入分发期数' }]}>
                        <InputNumber placeholder='请输入分发期数' disabled={curType!='add' || isDisable} style={{ width: '100%' }} min={1} />
                    </Form.Item>
                    <Form.Item style={{ width:'49%' }} label={toolTipContent('领取频率',TooltipTextList.cycleNum)} name='cycleNum' rules={[{ required: true, message: '请输入领取频率' }]}>
                        <InputNumber disabled={isDisable} placeholder='请输入领取频率' style={{ width: '100%' }} min={1} />
                    </Form.Item>
                </div>
                <div className='flexBox'>
                    <Form.Item style={{ width:'70%' }} label="权益包描述" name='description' rules={[{ required: true, message: '请输入权益包描述' }]}>
                        <TextArea style={{ height: 60, resize: 'none' }} showCount maxLength={50} disabled={isDisable} placeholder='请输入权益包描述' />
                    </Form.Item>
                    <Form.Item  label="领取周期" name='cycle' rules={[{ required: true, message: '请选择领取周期' }]}>
                        <Radio.Group disabled={isDisable}
                                options={cycleList}
                            />
                    </Form.Item>
                    {/* <Form.Item label="描述图片" name='descriptionImg' valuePropName="descriptionImg">
                        <Upload disabled={isDisable} {...uploadProps} listType='picture-card' onChange={()=>{ setCurImg('descriptionImg') }}   >
                        {activityImage.descriptionImg ? <div className='imgBox'>
                            <img src={activityImage.descriptionImg} alt="avatar" style={{ width: '100%' }} />
                        </div> : <button
                            style={{ color: 'inherit', cursor: 'inherit', border: 0, background: 'none' }}
                            type="button"
                            >
                            <PlusOutlined />
                            <div style={{ marginTop: 8 }}>上传权益包图片</div>
                            </button>}
                            
                        </Upload>
                    </Form.Item> */}
                </div>
                
                <div className='flexBox'>
                    <Form.Item style={{ width:'70%' }} label={toolTipContent('权益包使用说明',TooltipTextList.instructions)} name='instructions' rules={[{ required: true, message: '请输入权益包使用说明' }]}>
                        <TextArea style={{ height: 100, resize: 'none' }} disabled={isDisable} placeholder='请输入权益包使用说明' />
                    </Form.Item>
                    
                    <Form.Item label='使用说明图片' name='instructionsImg' valuePropName="instructionsImg">
                        <Tooltip title={imgTips('instructionsImg')}>
                            <Upload disabled={isDisable} {...uploadProps} listType='picture-card' onChange={()=>{ setCurImg('instructionsImg') }}  >
                            {activityImage.instructionsImg ? <div className='imgBox'><img src={activityImage.instructionsImg} alt="avatar" style={{ width: '100%' }} /> </div>: 

                            <button
                                style={{ color: 'inherit', cursor: 'inherit', border: 0, background: 'none' }}
                                type="button"
                                >
                                <PlusOutlined />
                                {imgTips('instructionsImg')}
                                {/* <div style={{ marginTop: 8,fontSize:'12px' }}>建议尺寸<span style={{color:'red'}}>{imgSizeList['instructionsImg']}</span>，大小不超过<span style={{color:'red'}}>500KB</span></div> */}
                                </button>
                                }
                                
                            </Upload>
                            {/* {exmpImg(ExampleImgList.instructionsImg)} */}
                        </Tooltip>
                    </Form.Item>
                </div>
                <div className='flexBox'>
                    <Space size="middle">
                        {
                            gradeList.map((item:{label:string,value:string})=>{
                                return <Form.Item key={item.value}   label={`档次${item.label}`}  name={item.value} rules={[{ required: true, message:tips(item.label)  }]}>
                                    <InputNumber disabled={isDisable} placeholder={`请输入档次${item.label}可领取次数`} min={1} style={{ width: '100%' }} />
                                </Form.Item>
                            })
                        }
                    </Space>
                </div>
                <div className='flexBox'>
                    {/* {
                        gradeList.map((item:{label:string,value:string})=>{
                            return <Form.Item key={item.value} style={{ width:'33%' }} label={`档次${item.label}`}  name={item.value} rules={[{ required: true, message: `请输入档次${item.label}可领取次数` }]}>
                                <InputNumber disabled={isDisable} placeholder={`请输入档次${item.label}可领取次数`} min={1} style={{ width: '100%' }} />
                            </Form.Item>
                        })
                    } */}
                </div>
                {/* <div style={{ width:'100%',display:'flex' }}>
                    <Form.Item label="开始日期" name='startDate' style={{ width:'50%' }} rules={[{ required: true, message: '请选择权益包开始日期' }]}>
                        <DatePicker disabledDate={disabledStartDate} style={{ width:'100%' }} placeholder='开始日期' />
                    </Form.Item>
                    <Form.Item label="结束日期" name='endDate' style={{ width:'50%' }} rules={[{ required: true, message: '请选择权益包结束日期' }]}>
                        <DatePicker disabledDate={disabledEndDate} style={{ width:'100%' }}  placeholder='结束日期' />
                    </Form.Item>
                </div> */}
                    
                
                
                {/* <Form.Item label="权益包状态" name='status' rules={[{ required: true, message: '请选择权益包状态' }]}>
                    <Radio.Group
                            options={[
                                {
                                    value: 0,
                                    label: '上架',
                                },
                                {
                                    value: 1,
                                    label: '下架',
                                }
                            ]}
                        />
                </Form.Item> */}
                
                {/* <Form.Item name="receiveMode" label="领取方式" rules={[{ required: true, message: '请选择领取方式' }]}>
                    <Checkbox.Group disabled={isDisable}>
                        <Row>
                            <Checkbox value={1} style={{ lineHeight: '32px' }}>
                            手机号
                            </Checkbox>
                            <Checkbox value={2} style={{ lineHeight: '32px' }}>
                            QQ号
                            </Checkbox>
                        </Row>
                    </Checkbox.Group>
                </Form.Item> */}
                
                {/* <Form.Item label="延迟领取天数" name='delayCollectionDay' rules={[{ required: true, message: '请输入延迟领取天数' }]}>
                    <InputNumber disabled={isDisable} placeholder='请输入延迟领取天数' style={{ width: '100%' }} min={1} />
                </Form.Item> */}
                <div className='' style={{ display:'flex',justifyContent:'space-between' }}>
                    {/* <Space size="middle"> */}
                <Form.Item label='权益包首页' name='imageUrl' valuePropName="imageUrl">
                    <Tooltip title={imgTips('imageUrl')}>
                        <Upload disabled={isDisable} {...uploadProps} listType='picture-card' onChange={()=>{ setCurImg('imageUrl') }}  >
                        {activityImage.imageUrl ? <div className='imgBox'><img src={activityImage.imageUrl} alt="avatar" style={{ width: '100%' }} /></div> : <button
                            style={{ color: 'inherit', cursor: 'inherit', border: 0, background: 'none' }}
                            type="button"
                            >
                            <PlusOutlined />
                            {imgTips('imageUrl')}
                            {/* <div style={{ marginTop: 8,fontSize:'12px' }}>建议尺寸<span style={{color:'red'}}>{imgSizeList['imageUrl']}</span>，大小不超过<span style={{color:'red'}}>500KB</span></div> */}
                            </button>}
                            
                        </Upload>
                        {exmpImg(ExampleImgList.imageUrl)}
                    </Tooltip>
                </Form.Item>
                
                <Form.Item label='权益包卡片' name='cardImg' valuePropName="cardImg">
                    <Tooltip title={imgTips('cardImg')}>
                        <Upload disabled={isDisable} {...uploadProps} listType='picture-card' onChange={()=>{ setCurImg('cardImg') }}  >
                        {activityImage.cardImg ? <div className='imgBox'><img src={activityImage.cardImg} alt="avatar" style={{ width: '100%' }} /></div> : <button
                            style={{ color: 'inherit', cursor: 'inherit', border: 0, background: 'none' }}
                            type="button"
                            >
                            <PlusOutlined />
                            {imgTips('cardImg')}
                            {/* <div style={{ marginTop: 8,fontSize:'12px' }}>建议尺寸<span style={{color:'red'}}>{imgSizeList['cardImg']}</span>，大小不超过<span style={{color:'red'}}>500KB</span></div> */}
                            </button>}
                            
                        </Upload>
                        {exmpImg(ExampleImgList.cardImg)}
                    </Tooltip>
                </Form.Item>
                <Form.Item label='权益包封面' name='backgroundImg' valuePropName="backgroundImg">
                    <Tooltip title={imgTips('backgroundImg')}>
                        <Upload disabled={isDisable} {...uploadProps} listType='picture-card' onChange={()=>{ setCurImg('backgroundImg') }} >
                        {activityImage.backgroundImg ? <div className='imgBox'><img src={activityImage.backgroundImg} alt="avatar" style={{ width: '100%' }} /></div> : <button
                            style={{ color: 'inherit', cursor: 'inherit', border: 0, background: 'none' }}
                            type="button"
                            >
                            <PlusOutlined />
                            {imgTips('backgroundImg')}
                            {/* <div style={{ marginTop: 8,fontSize:'12px' }}>建议尺寸<span style={{color:'red'}}>{imgSizeList['backgroundImg']}</span>，大小不超过<span style={{color:'red'}}>500KB</span></div> */}
                            </button>}
                            
                        </Upload>
                        {exmpImg(ExampleImgList.backgroundImg)}
                    </Tooltip>
                </Form.Item>
                {/* </Space> */}
                </div>
                
            </Form>
            <Image
                width={200}
                style={{ display: 'none' }}
                src=''
                preview={{
                    visible:previewVisible,
                    scaleStep:0.5,
                    src: previewImg,
                    onVisibleChange: (value:any) => {
                        setPreviewVisible(value);
                    },
                }}
            />
            </>
      </Modal>
    )
}

export default forwardRef(ActivityContent)